import React from "react";
import { forwardRef } from "react";
import { Icon, IconProps } from "./common";

const Play: Icon = forwardRef<SVGSVGElement, IconProps>(({ color = "currentColor", size = 24, ...rest }, ref) => <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
   <path d="M9.2295 5.78241C8.69692 5.4435 8 5.82607 8 6.45734V17.5427C8 18.1739 8.69692 18.5565 9.2295 18.2176L17.9394 12.6749C18.4334 12.3606 18.4334 11.6394 17.9394 11.3251L9.2295 5.78241Z" fill={color} />
</svg>);
export default Play;